<template>
    <div style="background-color: white">
        <div class="page-actions">
            <el-select v-model="queryType" placeholder="请选择">
                <el-option v-for="item in queryTypeList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
            </el-select>
            <el-input placeholder="请输入内容" clearable v-model="queryValue">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
        </div>
        <div style="margin-top: 20px;margin-left: 30px">
            <span style="padding-right: 35px">用户id</span>
            <el-input maxlength="100" style="width: 400px" v-model="userEditData.userId" disabled></el-input>
        </div>
        <el-collapse v-model="activeNames" style="margin-top: 30px;background-color: white">
            <el-collapse-item title="手机号修改" name="phonemsg" style="margin-left: 30px">
                <div style="margin-top: 20px;margin-left: 30px">
                    <span style="padding-right: 20px">国际区号</span>
                    <el-input maxlength="20" style="width: 400px" v-model="userEditData.telCountryCode"></el-input>
                </div>
                <div style="margin-top: 20px;margin-left: 30px">
                    <span style="padding-right: 48px">电话</span>
                    <el-input maxlength="20" style="width: 400px" v-model="userEditData.tel"></el-input>
                </div>
                <div style="margin-top: 20px;margin-left: 105px">
                    <el-button type="danger" :loading="phoneloading" @click="handleUpdateUserPhone">修改手机</el-button>
                </div>
            </el-collapse-item>
            <el-collapse-item title="邮箱修改" name="emailmsg" style="margin-left: 30px">
                <div style="margin-top: 20px;margin-left: 30px">
                    <span style="padding-right: 48px">邮箱</span>
                    <el-input maxlength="100" style="width: 400px" v-model="userEditData.email"></el-input>
                </div>
                <div style="margin-top: 20px;margin-left: 105px">
                    <el-button type="danger" :loading="emailloading" @click="handleUpdateUserEmail">修改邮箱</el-button>
                </div>
            </el-collapse-item>
        </el-collapse>
    </div>
</template>

<script>
    import api from './api';

    export default {
        name: "UserMsg",

        data() {
            return {
                queryTypeList: [
                    {label: '账号ID', value: '0'},
                    {label: '账号', value: '1'},
                    {label: '邀请码', value: '2'}
                ],
                queryType: "0",
                queryValue: "",
                userEditData: {
                    userId: "",
                    tel: "",
                    telCountryCode: "",
                    email: ""
                },
                phoneloading: false,
                emailloading: false,
                dialogVisible: false,
                activeNames: ["phonemsg", "emailmsg"]
            }
        },

        created() {

        },

        methods: {
            handleSearch() {
                this.getUserMsg();
            },
            getUserMsg() {
                api.getUserInfo({queryType: this.queryType, queryValue: this.queryValue}).then(({data}) => {
                    this.userEditData = {
                        userId: data.id,
                        tel: data.tel == null ? "" : data.tel,
                        telCountryCode: data.telCountryCode == null ? "" : data.telCountryCode,
                        email: data.email == null ? "" : data.email
                    };
                });
            },
            handleUpdateUserPhone() {
                if (this.userEditData.userId == "") {
                    this.$message.success('用户id不存在,请先搜索用户');
                    return
                }
                this.$confirm('此操作须谨慎，确定要修改吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.phoneloading = true;
                    api.alterTradeUserPhone(this.userEditData).then((data) => {
                        this.phoneloading = false;
                        this.$message.success(data.data);
                    });
                }).catch(() => {
                    this.phoneloading = false;
                });
            },
            handleUpdateUserEmail() {
                if (this.userEditData.userId == "") {
                    this.$message.success('用户id不存在');
                    return
                }
                this.$confirm('此操作须谨慎，确定要修改吗？', '提示', {
                    type: 'warning'
                }).then(() => {
                    this.emailloading = true;
                    api.alterTradeUserEmail(this.userEditData).then((data) => {
                        this.emailloading = false;
                        this.$message.success(data.data);
                    });
                }).catch(() => {
                    this.emailloading = false;
                });
            }
        },
    }
</script>

<style scoped>
    .page-actions{
        padding-top: 20px;
        margin-left: 30px;
    }
</style>
